import type { ImageType } from '@sparklayer-io/spark-dash-ui/components/ui/empty-state/types';
import { Button, Divider, EmptyState, NavigationLink, Text } from '@ui/themed';
import { t } from 'i18next';
import type { ActivePlanKey } from '../constants/features';
import { PlanAvailabilityBadge } from './plan-availability-badge';

type Details = {
  foreword?: string;
  use_cases?: {
    key: string;
    title: string;
    description: string;
  }[];
  afterword?: string;
  learnMoreURLText?: string;
};

export type UpsellProps = {
  title: string;
  subtitle?: string;
  imageType?: ImageType;
  /** Plans the feature is available on, listed in the order given. */
  plans: ActivePlanKey[];
  details: Details;
  onClickUpgrade: () => void;
  onClickLearn: () => void;
};

export function Upsell(props: UpsellProps) {
  return (
    <div className="w-full">
      <EmptyState title={props.title} subtitle={props.subtitle} imageType={props.imageType}>
        <div className="flex w-full flex-col items-center gap-6">
          <PlanAvailabilityBadge plans={props.plans} />
          <div className="flex flex-row gap-3">
            <Button variant="primary" onClick={props.onClickUpgrade}>
              {t('buttons:upgrade')}
            </Button>
            <Button variant="secondary" icon="externalLink" onClick={props.onClickLearn}>
              {t('links:learn_more')}
            </Button>
          </div>

          <div className="flex w-full flex-col gap-2 text-start">
            {props.details.foreword && (
              <>
                <Text variant="secondary">{props.details.foreword}</Text>
                <Divider />
              </>
            )}

            {props.details.use_cases?.map((detail) => (
              <div className="flex w-full flex-col gap-2" key={detail.key}>
                <div className="flex flex-col">
                  <Text variant="primary" bold={true}>
                    {detail.title}
                  </Text>
                  <Text variant="secondary">{detail.description}</Text>
                </div>
                <Divider />
              </div>
            ))}

            <div className="flex flex-col">
              {props.details.afterword && (
                <Text variant="secondary">{props.details.afterword}</Text>
              )}
              {props.details.learnMoreURLText && (
                <NavigationLink onClick={props.onClickLearn}>
                  {props.details.learnMoreURLText}
                </NavigationLink>
              )}
            </div>
          </div>
        </div>
      </EmptyState>
    </div>
  );
}
